import {
  Activity,
  BookOpenText,
  Braces,
  DatabaseZap,
  FilePlus2,
  FileSearch,
  FileText,
  Images,
  List,
  Mail,
  MailCheck,
  Plus,
  Search,
  ServerCog,
  Upload,
  UserPlus,
  Users,
  Webhook,
} from 'lucide-react';
import { apiReferencePermissions, referencedServices } from './apireference/catalog';
import type { FrontendModule } from './types';

export const moduleRegistry = Object.freeze<FrontendModule[]>([
  {
    id: 'dam',
    title: 'Mediendaten',
    description: 'Produktbilder suchen, prüfen, verschlagworten und kuratieren.',
    route: '/dam',
    icon: Images,
    requiredPermissions: ['dam.read'],
    enabled: true,
    accent: 'teal',
    navigation: [
      { title: 'Suche & Bestand', route: '/dam', icon: Search, end: true },
      { title: 'Asset anlegen', route: '/dam/upload', icon: Upload, requiredPermission: 'dam.write' },
      { title: 'Systemstatus', route: '/dam/status', icon: Activity },
    ],
  },
  {
    id: 'documents',
    title: 'Dokumente',
    description: 'Dokumente veröffentlichen, versionieren und Aufrufe auswerten.',
    route: '/documents',
    icon: FileText,
    requiredPermissions: ['docs.read'],
    enabled: true,
    accent: 'petrol',
    navigation: [
      { title: 'Suche & Bestand', route: '/documents', icon: FileSearch, end: true },
      { title: 'Dokument anlegen', route: '/documents/new', icon: FilePlus2, requiredPermission: 'docs.write' },
      { title: 'Systemstatus', route: '/documents/status', icon: Activity },
    ],
  },
  {
    id: 'sftpgo',
    title: 'Datentransfer',
    description: 'SFTP-Zugänge, Uploadvolumen und Webhook-Zustellung verwalten.',
    route: '/sftpgo',
    icon: ServerCog,
    requiredPermissions: ['sftp.read'],
    enabled: true,
    accent: 'aqua',
    navigation: [
      { title: 'Transferübersicht', route: '/sftpgo', icon: Activity, end: true },
      { title: 'Accounts', route: '/sftpgo/accounts', icon: Users, end: true },
      { title: 'Account anlegen', route: '/sftpgo/accounts/new', icon: UserPlus, requiredPermission: 'sftp.write' },
      { title: 'Webhooks', route: '/sftpgo/webhooks', icon: Webhook, end: true },
      { title: 'Webhook anlegen', route: '/sftpgo/webhooks/new', icon: Plus, requiredPermission: 'sftp.webhooks' },
      { title: 'Systemstatus', route: '/sftpgo/status', icon: ServerCog },
    ],
  },
  {
    id: 'masterdata',
    title: 'Stammdatenverwaltung',
    description: 'Artikel fuzzy durchsuchen, Detaildaten prüfen und Synfoxx-Synchronisation überwachen.',
    route: '/masterdata',
    icon: DatabaseZap,
    requiredPermissions: ['std.read'],
    enabled: true,
    accent: 'petrol',
    navigation: [
      { title: 'Artikelsuche', route: '/masterdata', icon: Search, end: true },
      { title: 'Alle Artikel', route: '/masterdata/articles', icon: List },
      { title: 'Synchronisation', route: '/masterdata/synchronization', icon: DatabaseZap },
      { title: 'Systemstatus', route: '/masterdata/status', icon: Activity },
    ],
  },
  {
    id: 'mail',
    title: 'Mailversand',
    description: 'Zustellstatus, Bounces und Beschwerden des zentralen Mailversands verfolgen.',
    route: '/mail',
    icon: Mail,
    requiredPermissions: ['mail.read'],
    enabled: true,
    accent: 'aqua',
    navigation: [
      { title: 'Zustellübersicht', route: '/mail', icon: MailCheck, end: true },
      { title: 'Systemstatus', route: '/mail/status', icon: Activity },
    ],
  },
  {
    id: 'apireference',
    title: 'API-Referenz',
    description: 'OpenAPI-Beschreibungen der Fachsysteme lesen und Aufrufe direkt ausführen.',
    route: '/api-reference',
    icon: Braces,
    requiredPermissions: [],
    // One service's reference is enough to see the module; each entry below checks its own.
    requiredAnyPermission: apiReferencePermissions,
    enabled: true,
    accent: 'petrol',
    navigation: referencedServices.map((service) => ({
      title: service.title,
      route: `/api-reference/${service.id}`,
      icon: BookOpenText,
      requiredPermission: service.permission,
    })),
  },
]);
